// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"8deb978e","993":"66b2ad31"}[chunkId] + ".chunk.js";
};